import { render } from "./ChallengeNewForm.vue?vue&type=template&id=0c5ed367"
import script from "./ChallengeNewForm.vue?vue&type=script&lang=js"
export * from "./ChallengeNewForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__